<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="success"
      @click="init"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-plus
    </v-icon>

    <slot/>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        :scrollable="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Vytvoriť import

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
              @submit.stop.prevent="submit"
          >
            <v-row>
              <v-col
                  cols="12"
              >
                <v-alert
                    type="info"
                    class="ma-0"
                >
                  Archív musí obsahovať súbor "database.csv". V prípade importu fotografií alebo výkresov je potrebné priložiť priečinok "photos/" alebo "dimensions/" s obrázkami, ktorých názvy zodpovedajú stĺpcu "photo" alebo "dimension" a je nastavená hodnota "photo_action" alebo "dimension_action" na 1.
                </v-alert>
              </v-col>

              <v-col
                  cols="12"
              >
                <ZipFiles
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Archív"
                    :File="ImportForm.File"
                    :errorsFile="errors.File"
                    @setFile="setFile"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-btn
                    type="submit"
                    :rounded="true"
                    :outlined="true"
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>

                  Vytvoriť
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Imports from '@/services/imports'

  import ZipFiles from '@/components/Files/Zip'

  export default {
    name: 'Create',
    components: {
      ZipFiles
    },
    data() {
      return {
        loading: false,
        dialog: false,
        ImportForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = true

        this.ImportForm = {
          File: null
        }

        this.errors = {}
      },
      setFile(File) {
        this.ImportForm.File = File
      },
      async submit() {
        this.loading = true

        await Imports
          .create({
            data: this.ImportForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
